import Head from "next/head"
import { t } from "translations"

import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { getStaticLayoutProps } from "lib/getStaticLayoutProps"

import Layout from "Components/Layout/Layout"
import DueDateCalculator from "Components/PregnancyOracle/DueDateCalculator/DueDate"

import ToolTemplatePage from "../../Components/PregnancyOracle/ToolTemplatePage"

export default function ContractionCounterPage({
    footer,
    megamenu
}: {
    footer: IContainerCard[]
    megamenu: IMegamenuCategory[]
}) {
    return (
        <Layout
            footer={footer}
            megamenu={megamenu}>
            <Head>
                <title>
                    {t.dueDateCalculator.title} | {t.siteTitle}
                </title>
                <meta
                    name="description"
                    content={`${t.dueDateCalculator.title}  | ${t.siteTitle}`}
                    key="desc"
                />
            </Head>
            <ToolTemplatePage
                toolItem={<DueDateCalculator />}
                instructionTitle={t.dueDateCalculator.instruction}
                instructions={[
                    {
                        icon: "pregnancOracleCalendar",
                        instructionText: t.dueDateCalculator.instruction1
                    },

                    {
                        icon: "timeSpan",
                        instructionText: t.dueDateCalculator.instruction2
                    },
                    {
                        icon: "start",
                        instructionText: t.dueDateCalculator.instruction3
                    },
                    {
                        icon: "print",
                        instructionText: t.dueDateCalculator.instruction4
                    }
                ]}
                accordions={[
                    {
                        title: t.dueDateCalculator.whatIsDueDate,
                        text: t.dueDateCalculator.whatIsDueDateText
                    },
                    {
                        title: t.dueDateCalculator.duedateSetOnUltrasound,
                        text: t.dueDateCalculator.duedateSetOnUltrasoundText
                    }
                ]}
                cloudText={t.dueDateCalculator.cloudText}
            />
        </Layout>
    )
}

export const getStaticProps = getStaticLayoutProps
